export const MIN_TARGET_ROAS = 1;
export const MAX_TARGET_ROAS = 200;
export const DEFAULT_RANGE_START = 5;
